import React, { useState } from 'react'
import { Box, Tabs, Tab, Container, useTheme } from '@mui/material'
import WebsiteVisitorsComponent from '../components/websiteVisitor/Visitor'
import SetupPage from '../components/websiteVisitor/Setup'
import HeaderWithPopover from '../components/HeaderWithPopover'
import { useGetMeAndWorkspaceQuery } from '../services/user-service'

export default function WebsiteVisitor () {
  const theme = useTheme()
  const [tabValue, setTabValue] = useState(0)
  const { data } = useGetMeAndWorkspaceQuery()

  const handleChange = (event, newValue) => {
    setTabValue(newValue)
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        width: '100%',
        height: '100%'
      }}
    >
      <Box
        sx={{
          width: '90%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'center'
        }}
      >
        <HeaderWithPopover
          title='Website Visitors'
          selectedTimeline={data?.workspace}
        />

        <Container maxWidth='100%'>
          <Tabs
            value={tabValue}
            onChange={handleChange}
            variant='fullWidth'
            indicatorColor='primary'
            sx={{
              display: 'flex',
              justifyContent: 'center',
              background: '#E1E3EC',
              border: '1ps solid #D7D9E6',
              borderRadius: '8px',
              mb: 3,
              '& .MuiTab-root': {
                textTransform: 'none',
                fontWeight: 600,
                borderRadius: '8px'
              },
              '& .Mui-selected': {
                backgroundColor: '#ffffff',
                color: `${theme.palette.primary.main}`,
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
              },
              '& .MuiTabs-indicator': {
                display: 'none'
              }
            }}
          >
            <Tab
              label='Website Visitors'
              sx={{
                my: '5px',
                mx: '5px',
                px: 6,
                py: '4px',
                fontSize: '14px',
                fontWeight: 600
              }}
            />
            <Tab
              label='Setup'
              sx={{
                my: '5px',
                mx: '5px',
                px: 6,
                py: '4px',
                fontSize: '14px',
                fontWeight: 600
              }}
            />
          </Tabs>

          {tabValue === 0 && <WebsiteVisitorsComponent />}
          {tabValue === 1 && <SetupPage />}
        </Container>
      </Box>
    </Box>
  )
}
